import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=46107099&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46107099')) {
      api.createRecord('46107099', component.options)
    } else {
      api.reload('46107099', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=46107099&", function () {
      api.rerender('46107099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/example/upload/upload.vue"
export default component.exports